const dialogNames = {};

dialogNames.StartupSettings = 'StartupSettings';
dialogNames.PostEditor = 'PostEditor';

export default dialogNames;